import React from 'react';

import Countdown from 'react-countdown';

import { green, red } from '@mui/material/colors';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface TSTimerProps {
  startedAt: string;
  timeLimit: number; // Minutes
  onTimeOut?: () => void;
}

const TSTimer = (props: TSTimerProps) => {
  const { timeLimit, onTimeOut, startedAt } = props;

  const timeLimitMilliseconds = timeLimit * 60 * 1000;
  const elapsedTime = Date.now() - Date.parse(startedAt);
  const timeLeft = timeLimitMilliseconds - elapsedTime;

  return (
    <Countdown
      date={Date.now() + timeLeft}
      overtime
      onComplete={onTimeOut}
      renderer={({ hours, minutes, seconds, completed }) => (
        <Box
          sx={(theme) => ({
            height: 24,
            backgroundColor: completed ? red[300] : green[300],
            position: 'fixed',
            top: 64,
            left: 0,
            width: '100%',
            [theme.breakpoints.down('md')]: {
              top: 56,
            },
            zIndex: 2000,
          })}
        >
          <Box sx={{ position: 'relative', height: '100%' }}>
            <Box width="100%" textAlign="center">
              <Typography color="white">
                {String(hours).padStart(2, '0')}:{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    />
  );
};

export default TSTimer;
